import { createPlugin } from '@backstage/core-plugin-api';
import { TechDocsAddonLocations, createTechDocsAddonExtension } from '@backstage/plugin-techdocs-react';
import { HideNavSiteTitle } from './HideNavSiteTitle';
import { TextSizeControl } from './TextSizeControl';

/** DevHub-specific TechDocs reader tweaks. */
export const devHubTechDocsPlugin = createPlugin({
  id: 'devhub-techdocs',
});

/** Visible A- / 100% / A+ text size control in the docs subheader. */
export const DocTextSize = devHubTechDocsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'DocTextSize',
    location: TechDocsAddonLocations.Subheader,
    component: TextSizeControl,
  }),
);

/** Removes the site / repository name above the left navigation tree. */
export const HideDocNavTitle = devHubTechDocsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'HideDocNavTitle',
    location: TechDocsAddonLocations.Content,
    component: HideNavSiteTitle,
  }),
);

export { DocsIndexHeader, TopDocsSection } from './TopDocsSection';
